














import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import permissionGuard from '@/guards/permission-guard';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_PAYCHECK_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitPaycheckSetting_currentUnit } from '@/queries/__generated__/unitPaycheckSetting';
import WorkRelationReport from './WorkRelationReport.vue';
import {
  GQL_yearlyReportForEmployeePdf,
  GQL_yearlyReportForEmployeePdfVariables,
  GQL_yearlyReportForEmployeePdf_paychecksByYear,
} from '@/queries/__generated__/yearlyReportForEmployeePdf';
import gql from 'graphql-tag';

const YEARLY_REPORT_FOR_EMPLOYEE_REPORT_PDF = gql`
  query yearlyReportForEmployeePdf($unitId: ID!, $year: Int!, $workRelationId: ID!) {
    yearlyReportForEmployee(unitId: $unitId, year: $year, workRelationId: $workRelationId) {
      workRelation {
        id
      }
      number
      description
      calculationType
      car {
        id
        name
        registrationNumber
      }
      project {
        id
        code
        name
      }
      department {
        id
        code
        name
        unit {
          id
        }
      }
      quantity
      rate
      sum
      vacationMoneyBaseAmount
    }
    workRelation(id: $workRelationId) {
      id
      shiftType
      employmentType
      occupation {
        id
        name
      }
      subUnit {
        id
        name
      }
      startDate
      employmentPercentage
      endDate
      endReason
      leaveAndLayoffs {
        id
        description
        startDate
        endDate
      }
      employee {
        id
        firstName
        lastName
        address
        zip
        city
        socialSecurityNumber
        temporarySocialSecurityNumber
      }
    }
    paychecksByYear(unitId: $unitId, year: $year, workRelationId: $workRelationId) {
      id
      number
      paidDate
      paycheckLines {
        id
        description
        sum
      }
    }
  }
`;

@Component({
  components: {
    WorkRelationReport,
  },
  beforeRouteEnter(to, from, next) {
    permissionGuard('canCreatePaychecks', to, from, next)
      .catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class YearlyReportForEmployeePdf extends Vue {
  @Prop({ type: Number, required: true }) private year!: number;
  @Prop({ type: String, required: true }) private workRelationId!: string;

  @SmartQuery(UNIT_PAYCHECK_SETTINGS) private currentUnit?: GQL_unitPaycheckSetting_currentUnit;

  @SmartQuery<YearlyReportForEmployeePdf, GQL_yearlyReportForEmployeePdf, GQL_yearlyReportForEmployeePdfVariables>({
    query: YEARLY_REPORT_FOR_EMPLOYEE_REPORT_PDF,
    skip() { return !this.currentUnit },
    variables() {
      return {
        unitId: this.currentUnit!.id,
        year: this.year,
        workRelationId: this.workRelationId,
      };
    },
    result({ data }) {
      data.paychecksByYear.forEach(paycheck => {
        const paidYear = paycheck.paidDate ? this.$dayjs.strict(paycheck.paidDate).year() : null;

        if (paidYear === this.year) {
          this.paychecksPaid.push(paycheck);
        } else {
          this.paychecksUnpaid.push(paycheck);
        }
      });
    },
    update: data => data,
  }) private reportData?: GQL_yearlyReportForEmployeePdf;

  private paychecksPaid: GQL_yearlyReportForEmployeePdf_paychecksByYear[] = [];
  private paychecksUnpaid: GQL_yearlyReportForEmployeePdf_paychecksByYear[] = [];

  @Provide() private isPdf = true;
}
